// require("./tailwind.css")

import { setup } from './wm-intro.ts';
import { initVue } from './vue.ts';

declare global {
    interface Window {
        vm: any, // Vue.js instance
        observer: any
    }
}

document.addEventListener('DOMContentLoaded', () => {
  initVue();

  window.setTimeout(() => {
    setup();

  }, 200)


})
